export default __webpack_public_path__ + "static/media/Maduro-4.f5ab6676.png";